module.exports = __webpack_public_path__ + "static/media/centenarioUlda.4a5d4059.jpg";